export const GOOGLE_ADS_ID = "AW-18425187964";
const conversionLabel = process.env.REACT_APP_GOOGLE_ADS_CALL_LABEL;

export const trackCallClick = (href) => (event) => {
  if (typeof window.gtag !== "function" || !conversionLabel) return;
  event.preventDefault();
  let completed = false;
  const complete = () => {
    if (completed) return;
    completed = true;
    window.location.href = href;
  };
  window.gtag("event", "conversion", {
    send_to: `${GOOGLE_ADS_ID}/${conversionLabel}`,
    value: 1.0,
    currency: "USD",
    event_callback: complete,
    event_timeout: 1000,
  });
  window.setTimeout(complete, 1100);
};
